import React from 'react';
import './PortfolioIntro.css';

/**
 * PortfolioIntro — what this page is for, shown only while the portfolio is empty.
 *
 * 2026-09-11: added because the commercial core of the product was never
 * explained. A brand-new user landed here and the only guidance on the page was
 * an empty state reading "Upload a portfolio CSV to begin analysis" — which
 * demands a file most people do not have, and never mentions that you can simply
 * type your holdings in the editor directly below it. Nothing anywhere said what
 * actually happens next: that AlphaGrade scores the WHOLE portfolio, saves it,
 * and lets you re-grade it tomorrow and watch it move.
 *
 * The measured cost of that silence: 2 of 40 registered users had ever created a
 * portfolio. See project_funnel_diagnosis in the session notes.
 *
 * Disappears as soon as there is a position, so it never nags an existing user.
 */
export default function PortfolioIntro() {
  return (
    <div className="pintro">
      <h2 className="pintro-title">Grade your whole portfolio, not just one stock</h2>
      <p className="pintro-lead">
        Add what you own and AlphaGrade scores every position across the same 34 tests it
        runs on a single ticker, then rolls them into one conviction score for the portfolio
        as a whole.
      </p>

      <ol className="pintro-steps">
        <li>
          <span className="pintro-step-n">1</span>
          <div>
            <strong>Add your holdings</strong>
            <p>
              Type them into <em>My Portfolio</em> below — ticker, shares, and what you paid.
              Or upload a CSV if you already have one exported from your broker.
            </p>
          </div>
        </li>
        <li>
          <span className="pintro-step-n">2</span>
          <div>
            <strong>Grade the portfolio</strong>
            <p>
              Every position gets its own score and reasoning, plus a single conviction score
              for the whole portfolio and where your risk is concentrated.
            </p>
          </div>
        </li>
        <li>
          <span className="pintro-step-n">3</span>
          <div>
            <strong>Come back tomorrow</strong>
            <p>
              Your portfolio is saved. Re-grade it any day and AlphaGrade keeps the history,
              so you can see what changed and which holdings moved.
            </p>
          </div>
        </li>
      </ol>

      <p className="pintro-foot">
        Nothing is shared. Your positions are private to your account.
      </p>
    </div>
  );
}
